type WidaScores = {
  wida_reading: string | null;
  wida_writing: string | null;
  wida_listening: string | null;
  wida_speaking: string | null;
};

type Submission = WidaScores & {
  id: number;
  date_completed: string;
  completion_time: number;
  lexile_reading: string | null;
  user: number;
  evaluation: number;
};

type Evaluation = {
  id: number;
  type: string;
  override_default: boolean;
  baseline: string;
  classroom: number;
  district: number | null;
};

type StudentEvaluation = {
  submission: Submission;
  evaluation: Evaluation;
};

type StudentEntry = {
  evaluations: StudentEvaluation[];
};

type StudentData = {
  [studentId: string]: StudentEntry;
};

type WidaAverage = {
  wida_reading: number;
  wida_writing: number;
  wida_listening: number;
  wida_speaking: number;
};

class StudentMetrics {
  public data: StudentData;

  constructor(data: StudentData) {
    this.data = data;
  }

  public get averages(): WidaAverage {
    const totals = {
      wida_reading: 0,
      wida_writing: 0,
      wida_listening: 0,
      wida_speaking: 0,
    };

    let count = 0;

    for (const studentId in this.data) {
      const evaluations = this.data[studentId].evaluations;

      if (evaluations.length > 0) {
        // Find the most recent evaluation by date_completed
        const latest = evaluations.reduce((a, b) =>
          new Date(a.submission.date_completed) >
          new Date(b.submission.date_completed)
            ? a
            : b,
        ).submission;

        // Parse and sum if the fields are not null
        const scores = [
          'wida_reading',
          'wida_writing',
          'wida_listening',
          'wida_speaking',
        ] as const;
        let valid = true;

        for (const key of scores) {
          if (latest[key] === null) {
            valid = false;
            break;
          }
        }

        if (valid) {
          totals.wida_reading += parseFloat(latest.wida_reading!);
          totals.wida_writing += parseFloat(latest.wida_writing!);
          totals.wida_listening += parseFloat(latest.wida_listening!);
          totals.wida_speaking += parseFloat(latest.wida_speaking!);
          count++;
        }
      }
    }

    return count > 0
      ? {
          wida_reading: totals.wida_reading / count,
          wida_writing: totals.wida_writing / count,
          wida_listening: totals.wida_listening / count,
          wida_speaking: totals.wida_speaking / count,
        }
      : {
          wida_reading: 0,
          wida_writing: 0,
          wida_listening: 0,
          wida_speaking: 0,
        };
  }
}

export default StudentMetrics;
